import { BOBBY_API_ROOT } from '@/composables/api/constants';

export const USER_DEPOTS_PATH = `${BOBBY_API_ROOT}/depots`;
